import { Link } from "react-router-dom";
import { ArrowUpRight, CalendarClock, KeyRound, Repeat, Crown } from "lucide-react";

const SERVICES = [
  { to: "/noleggio/breve", Icon: CalendarClock, tag: "Da 1 giorno", title: "Noleggio breve termine", text: "Giornaliero, weekend, settimanale o mensile. Senza carta di credito, consegna rapida a Roma EUR." },
  { to: "/noleggio/lungo-termine", Icon: KeyRound, tag: "12 – 48 mesi", title: "Noleggio lungo termine", text: "Canone fisso tutto incluso: assicurazione, manutenzione, bollo e assistenza stradale." },
  { to: "/noleggio/rent-to-buy", Icon: Repeat, tag: "Noleggi e poi riscatti", title: "Rent to Buy", text: "Guida subito la tua auto con un canone mensile e decidi alla fine se riscattarla." },
  { to: "/abbonamenti", Icon: Crown, tag: "12 mesi", title: "Abbonamento auto", text: "Un canone una tantum, l'auto della tua categoria sempre pronta quando ti serve." },
];

/** Home "menu dei servizi": entry points to every rental formula. */
export default function ServicesMenu() {
  return (
    <section data-testid="services-menu" className="py-16 md:py-24 bg-[#0a0a0a] border-y border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="mb-10 md:mb-14 max-w-2xl">
          <div className="text-[#22ff66] text-xs uppercase tracking-[0.3em] font-semibold mb-3">I nostri servizi</div>
          <h2 className="heading-uc text-3xl md:text-5xl">Scegli la formula giusta per te</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {SERVICES.map(({ to, Icon, tag, title, text }, i) => (
            <Link
              key={to}
              to={to}
              data-testid={`service-card-${to.split("/").pop()}`}
              className="group relative flex flex-col justify-between sm:min-h-[260px] p-6 md:p-7 border border-white/10 bg-[#111] hover:border-[#22ff66] hover:-translate-y-1 transition-[transform,border-color] duration-300 animate-[fadeUp_.6s_ease_both]"
              style={{ animationDelay: `${i * 90}ms` }}
            >
              <div>
                <div className="flex items-start justify-between mb-5 sm:mb-8">
                  <span className="w-12 h-12 rounded-full bg-[#22ff66]/10 border border-[#22ff66]/30 flex items-center justify-center text-[#22ff66] group-hover:bg-[#22ff66] group-hover:text-black transition-colors">
                    <Icon className="w-5 h-5" />
                  </span>
                  <ArrowUpRight className="w-5 h-5 text-white/40 group-hover:text-[#22ff66] group-hover:rotate-45 transition-[transform,color] duration-300" />
                </div>
                <div className="text-[10px] uppercase tracking-[0.25em] text-white/50 font-semibold mb-2">{tag}</div>
                <h3 className="heading-uc text-xl md:text-2xl mb-3 leading-tight">{title}</h3>
                <p className="text-white/60 text-sm leading-relaxed">{text}</p>
              </div>
              <span className="mt-6 text-xs uppercase tracking-widest font-bold text-[#22ff66]">Scopri →</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
